import { ChromosomesService } from 'Common/services';
export const getInitialState = () => ({
    chromosomes: ChromosomesService.empty,
});
